import { map } from 'lodash';
import { setAllergies } from './actions';
import { currentPatientIdSelector } from '../patient';
import AllergiesService from './AllergiesService';

// HELPERS
const toAllergiesRequest = ({ comments, date, reaction, type, actions }) => ({
  comments: comments,
  actions: actions,
  description: type,
  lastReactionDate: date,
  reaction: reaction,
});

const toRequest = (allergies, patientId) => ({
  allergies: map(allergies, toAllergiesRequest),
  patientId,
});

// THUNKS
export const fetchAllergiesAsync = () => (dispatch, getState) => {
  const state = getState();
  const patientId = currentPatientIdSelector(state);

  return dispatch(AllergiesService.getByPatientId(patientId)).then(allergies =>
    dispatch(setAllergies(allergies)),
  );
};

export const saveAllergiesAsync = allergies => (dispatch, getState) => {
  const state = getState();
  const patientId = currentPatientIdSelector(state);

  return dispatch(
    AllergiesService.create(toRequest(allergies, patientId)),
  ).then(() => dispatch(setAllergies(allergies)));
};



// WEBPACK FOOTER //
// ./src/lib/dataLayer/allergies/thunks.js